/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useStateContext } from '../../state/context'
import { AiOutlineCaretDown } from 'react-icons/ai'
import { TbReportAnalytics } from 'react-icons/tb'
import { useDispatch, useSelector } from 'react-redux'
import { getAllRadiologyReportRequest } from '../../state/actions/radiologist.actions'
import { setRadiologyGenerateInvoice, setRadiologyViewReport } from '../../state/actions/actions'
import { getAllBillings } from '../../state/actions/records.actions'
import RadiologyPagination from './RadiologyPagination'
import { PageTitle } from '../../components'
import Pagination from '../../components/utils/Pagination'


const RadiologistReports = () => {
	const dispatch = useDispatch()

	const { modals, setModals } = useStateContext()

	const { all_rad_report_requests } = useSelector((state) => state.radiologist)

	const [currentData, setCurrentData] = useState([])
	const [showActionsDropdown, setShowActionsDropdown] = useState()
	const [currentRadInvestigationIndex, setcurrentRadInvestigationIndex] = useState(0)

	useEffect(() => {
		dispatch(getAllRadiologyReportRequest())
		dispatch(getAllBillings())

		if (all_rad_report_requests != null) {
			setcurrentRadInvestigationIndex(all_rad_report_requests[0]?.pkid)
		}
	}, [modals.showUploadReportModal, modals.showRadiologyGenerateInvoiceModal])

	return (
		<div>
			<PageTitle type={'radiologist-reports'} />

			<div className='flex flex-col w-full cursor-pointer'>
				<div className='py-2'>
					<div className='flex justify-start items-center space-x-4 bg-gray-200  p-1'>
						<h4 className='text-dark-blue text-[14px] font-bold'>
							Report
						</h4>
						<TbReportAnalytics
							className='text-dark-blue'
							size={20}
						/>
						{/* <input type="text" name="filter" placeholder='Search patient by name or patient number' id="" className='ml-2 pl-4 text-sm rounded h-[30px] w-[400px]' onChange={(e) => handleChange(e, e.target.name)} /> */}
					</div>
					<table className='border rounded w-full cursor-default'>
						<thead className=''>
							<tr>
								<th
									scope='col'
									className='text-[10px] font-medium text-gray-900 px-4 text-left'
								>
									S/N
								</th>

								<th
									scope='col'
									className='text-[10px] font-medium text-gray-900 text-left'
								>
									Patient Name
								</th>
								<th
									scope='col'
									className='text-[10px] font-medium text-gray-900  text-left'
								>
									Patient Number
								</th>
								<th
									scope='col'
									className='text-[10px] font-medium text-gray-900  text-left'
								>
									Investigation type
								</th>
								<th
									scope='col'
									className='text-[10px] font-medium text-gray-900  text-left'
								>
									Doctor
								</th>
								<th
									scope='col'
									className='text-[10px] font-medium text-gray-900  text-left'
								>
									Invoice
								</th>


								<th
									scope='col'
									className='text-[10px] font-medium text-gray-900 text-left'
								>

								</th>
							</tr>
						</thead>
						<tbody>
							{currentData?.map((report, index) => (
								<tr
									// className='relative'
									className={`${report?.patient_details?.nhis_id ? 'bg-indigo-20 text-gray-900' : 'text-gray-900'} relative'`}
									key={index}
								>
									<td className='px-4 py-2 whitespace-nowrap text-[10px] font-medium text-gray-900'>
										{index + 1}
									</td>
									<td className='text-[10px] text-gray-900 font-light py-2 whitespace-nowrap'>
										{report.patient?.first_name} {report.patient?.last_name}  {report?.patient_details?.nhis_id && <sub className="font-medium text-[8px]">(NHIS)</sub>}
									</td>
									<td className='text-[10px] text-gray-900 font-light py-2 whitespace-nowrap'>
										{report.patient_details?.patient_number}
									</td>
									<td className='text-[10px] text-gray-900 font-light py-2 whitespace-nowrap'>
										{report?.investigation_type_details?.type}
									</td>
									<td className='text-[10px] text-gray-900 font-light py-2 whitespace-nowrap'>
										Dr. {report.request_doctor?.first_name} {report.request_doctor?.last_name}
									</td>
									<td className='text-[10px] text-gray-900 font-light py-2 whitespace-nowrap'>
										{report.invoice_status != null && (
											report?.invoice_status?.is_paid ? "Paid" : "Pending"
										)}
										{report.invoice_status == null && (
											<p>Not generated</p>
										)}
									</td>


									<td className=' text-[10px] text-gray-900 font-light py-2 whitespace-nowrap'>
										<div className='relative'>
											<button
												type='button'
												className='inline-block px-2 py-2.5 bg-dark-green text-white font-medium text-[10px] leading-tight uppercase rounded shadow-md hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:bg-dark-green active:shadow-lg transition duration-500 ease'
												onClick={() => {
													setShowActionsDropdown(!showActionsDropdown)

													setcurrentRadInvestigationIndex(report.pkid)
												}}
											>
												<span className='flex items-center justify-between'>
													Actions <AiOutlineCaretDown />
												</span>
											</button>

											{showActionsDropdown && currentRadInvestigationIndex === report.pkid && (
												<div className='absolute z-20 top-[30px] left-[-60px] p-1 bg-white shadow-lg border border-gray-200 rounded w-[150px]'>
													<div className='flex flex-col justify-start space-y-5'>

														{report.invoice_status == null && (
															<button
																onClick={() => {
																	setShowActionsDropdown(!showActionsDropdown)
																	const data = {
																		patient_id: report.user_id,
																		first_name: report.patient.first_name,
																		last_name: report.patient.last_name,
																		patient_no: report.patient_number,
																		investigation_pkid: report.pkid
																	}

																	dispatch(setRadiologyGenerateInvoice({ data }))
																	setModals({
																		...modals,
																		showRadiologyGenerateInvoiceModal:
																			!modals.showRadiologyGenerateInvoiceModal,
																	})
																}}
																className='hover:bg-green-200 hover:text-gray-600 rounded p-2'
															>
																Generate Invoice
															</button>
														)}
														{report.invoice_status != null && (
															<button disabled>Invoice Generated</button>
														)}

														{report.investigation_conducted == false && (
															<button
																onClick={() => {
																	setShowActionsDropdown(!showActionsDropdown)
																	const data = {
																		patient_id: report.user_id,
																		first_name: report.patient.first_name,
																		last_name: report.patient.last_name,
																		patient_no: report.patient_number,
																		report_id: report.id
																	}

																	dispatch(setRadiologyGenerateInvoice({ data }))
																	setModals({
																		...modals,
																		showUploadReportModal:
																			!modals.showUploadReportModal,
																	})
																}}


																className='hover:bg-green-200 hover:text-gray-600 rounded p-2'
															>
																Upload Investigation
															</button>
														)}
														{report.investigation_conducted == true && (
															<button disabled>Report uploaded</button>
														)}
														<button
															onClick={() => {
																const data = {
																	patient_id: report.user_id,
																	first_name: report.patient.first_name,
																	last_name: report.patient.last_name,
																	patient_no: report.patient_number,
																	image: report.image_report,
																	report_id: report.id,
																	test_report: report.text_report,
																	test_cat: report.investigation_type_details?.category,
																	test_type: report.investigation_type_details?.type

																}

																dispatch(setRadiologyViewReport({ data }))
																setShowActionsDropdown(!showActionsDropdown)
																setModals({
																	...modals,
																	showRadiologyViewReportModal:
																		!modals.showRadiologyViewReportModal,
																})
															}}

															className='hover:bg-green-200 hover:text-gray-600 rounded p-2'
														>
															See Investigation
														</button>
													</div>
												</div>
											)}
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>

					<Pagination
						data={all_rad_report_requests}
						currentData={currentData}
						setCurrentData={setCurrentData}
					/>
				</div>
			</div>
		</div>
	)
}

export default RadiologistReports